import CtaButton from "./CtaButton";

// headline quebrada em linhas; cada palavra entra com stagger de 60ms no load.
// palavras com serif: true ganham a itálica serifada de destaque.
const HEADLINE_LINES: { text: string; serif?: boolean }[][] = [
  [{ text: "o" }, { text: "desafio" }],
  [{ text: "já" }, { text: "começou.", serif: true }],
];

const Hero = () => {
  let wordIndex = 0;

  return (
    <section className="relative flex min-h-svh flex-col items-center justify-center overflow-hidden px-6 py-16 text-center">
      {/* foto de fundo: vertical no mobile, horizontal no desktop */}
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src="/escape21/hero-vertical.jpg"
          alt=""
          className="e21-kenburns h-full w-full object-cover md:hidden"
        />
        <img
          src="/escape21/hero-horizontal.jpg"
          alt=""
          className="e21-kenburns hidden h-full w-full object-cover md:block"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/70 to-white" />
      </div>

      {/* assinatura de marca, discreta */}
      <span className="absolute left-6 top-6 z-10 font-mono text-[10px] uppercase tracking-[0.3em] text-black/25">
        ordinary dies here
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <h1 className="text-[2.75rem] font-extrabold leading-[1.02] tracking-[-0.03em] sm:text-6xl md:text-7xl">
          {HEADLINE_LINES.map((line, li) => (
            <span key={li} className="block">
              {line.map((word) => {
                const delay = wordIndex++ * 60;
                return (
                  <span
                    key={`${li}-${word.text}-${delay}`}
                    className={`e21-word mr-[0.28em] last:mr-0 ${word.serif ? "e21-serif" : ""}`}
                    style={{ animationDelay: `${delay}ms` }}
                  >
                    {word.text}
                  </span>
                );
              })}
            </span>
          ))}
        </h1>

        <p className="e21-word mt-8 max-w-md text-base leading-relaxed text-black/60 sm:text-lg" style={{ animationDelay: "480ms" }}>
          essa turma já tá dentro. mas a próxima pode ser a tua. entra na lista
          de espera da comunidade agora e sai na frente quando abrir de novo.
          vai por mim, tu vai agradecer. tmj.
        </p>

        <div className="e21-word mt-10" style={{ animationDelay: "620ms" }}>
          <CtaButton label="entrar na lista de espera" main className="px-10 py-5 text-lg" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
